import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function RolesRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.Roles />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.Roles />
            </Route>
            <Route path={ `${ path }/page` } exact>
                <Pages.Roles />
            </Route>
            <Route path={ `${ path }/:id` } >
                { ({ match, history }) => <Pages.Role match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.Role />
            </Route>
        </Switch>
    );
}

